import { IObservable, Subject, generatePath, iconX, iconY } from '~/rage/utils';
import { IRadialMenuItem } from '~/shared';
import { RpcService } from '../RpcService';
import { VarsService } from '../VarsService';
import {
	IRadialMenuService,
	paginateMenuItems,
} from './radialMenuServiceTypes';

export class RadialMenuService implements IRadialMenuService {
	private readonly pathCache: Record<number, string[]> = {};
	private readonly iconXCache: Record<number, number[]> = {};
	private readonly iconYCache: Record<number, number[]> = {};

	private readonly items = new Subject<IRadialMenuItem[]>([]);

	constructor(
		private readonly vars: VarsService,
		private readonly rpc: RpcService,
	) {
		// this.precalculate();

		this.vars
			.get<IRadialMenuItem[]>('radialMenuItems', [])
			.subscribe((items) => {
				// const count = items.length;

				// if (!this.pathCache[count]) {
				// 	this.calculateForCount(count);
				// }

				// const withCoords = items.map((item, index) => ({
				// 	...item,
				// 	path: this.pathCache[count][index],
				// 	iconX: this.iconXCache[count][index],
				// 	iconY: this.iconYCache[count][index],
				// }));

				// this.items$.next(withCoords);
				const paginatedItems = paginateMenuItems(items);
				this.items.next(paginatedItems);
			});
	}

	public getItems(): IObservable<IRadialMenuItem[]> {
		return this.items;
	}

	public getBottomCaption(): IObservable<string> {
		return this.vars.get('radialMenuBottomCaption', '');
	}

	public async selectItem(action: string): Promise<void> {
		return await this.rpc.invokeClient('radialMenu:selectItem', { action });
	}

	public async exit(): Promise<void> {
		return await this.rpc.invokeClient('radialMenu:exit');
	}

	private precalculate(max: number = 12): void {
		for (let count = 2; count <= max; count++) {
			this.calculateForCount(count);
		}
	}

	private calculateForCount(count: number): void {
		if (this.pathCache[count]) {
			return;
		}

		this.pathCache[count] = [];
		this.iconXCache[count] = [];
		this.iconYCache[count] = [];

		for (let index = 0; index < count; index++) {
			this.pathCache[count][index] = generatePath(count, index);
			this.iconXCache[count][index] = iconX(index, count);
			this.iconYCache[count][index] = iconY(index, count);
		}
	}
}
